<template>
  <footer
    class="flex items-center justify-between text-grey-darker bg-grey-lighter z-40 fixed invisible md:visible pin-b pin-l w-full py-1 px-3 transition-all"
    :class="footer_class"
  >
 
      <div class="flex items-center">
        <img
          class="mh-8 mx-2"
          alt="Ministère des Technologies de la Communication et de la Transformation Digitale"
          src="../assets/img/drapeau.png"
        />
        <span class=" text-xxs opacity-60"
          >{{ $t('auth.ministry') }}</span
        >
      </div>
      <div class="sm:w-70 w-60 text-right text-xxs">
        {{ $t('auth.technology_by') }}
        <a class="inline-block text-sm font-bold no-underline cursor-pointer transition-all text-grey-darker hover:text-grey-darker" href="https://www.satoripop.com/" target="_blank">
          <img src="../assets/img/satoripop.svg" class="ml-1 w-3 align-middle" alt="satoripop" title="satoripop">
        </a>
      </div>
    </footer>
</template>

<style></style>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Footer",
  data() {
    return {
      footer_class: "md:ml-60"
    };
  },
  watch: {
    barActive() {
      if (this.barActive == 1) this.footer_class = "md:pl-22";
      else this.footer_class = "md:pl-60";
    }
  },
  computed: {
    ...mapGetters(["barActive"])
  },
  mounted() {
    if (this.barActive == 1) this.footer_class = "md:pl-22";
    else this.footer_class = "md:pl-60";
  }
};
</script>
